import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { FooterSection, LeadingTitle, SimpleMenu } from "@components";
import "./HistoryProfile.scss";
import { ProfileBukopinAPI, BannerProfileAPI } from "@api";
import { useTranslation } from "react-i18next";
import { TitleComponent } from "../../../common/components/TitleComponent";
import { useParams } from "react-router-dom";
import { ThumbnailBig } from "../../../common/components";
import MenuProfile from "../MenuProfile";
import "./HistoryProfile.scss";

import imageBF from "../../../assets/images/bukopin-finance.png";
import imageBS from "../../../assets/images/bukopin-syariah.png";
const subsidiaryImage = [imageBF, imageBS];

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const HistoryProfileContainer = styled.div`
  background-color: #fff;
  margin-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const HistoryProfile = function () {
  const { id } = useParams();
  const { t } = useTranslation();
  const [data, setdata] = useState([]);
  const [shortDesc, setShortDesc] = useState({});
  const [isLoading, setisLoading] = useState(false);

  const pages = [
    "history",
    "vision-mission",
    "business-segment",
    "subsidiary",
    "corporate-culture",
    "award",
    "correspondent-bank",
    "institute-bank",
    "contact-us",
  ];
  const locs = [
    "riwayat_singkat",
    "visi_misi",
    "segment_bisnis",
    "anak_perusahaan",
    "budaya_perusahaan",
    "penghargaan",
    "bank_koresponden",
    "lembaga_penunjang",
    "hub_kami",
  ];
  const active = pages.indexOf(id);

  const getDesc = async function () {
    const { data } = await BannerProfileAPI({ loc: locs[active] });
    setShortDesc(data.data ? data.data[0] : {});
  };

  const loadData = async function () {
    const { data } = await ProfileBukopinAPI("");    
    setdata(data.data);
  };

  useEffect(() => {
    setisLoading(true);
    getDesc();
    loadData();
    setisLoading(false);
  }, []);

  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <Container>
        <ThumbnailBig
          title={isLoading ? "" : shortDesc.title}
          desc={isLoading ? "" : shortDesc.description}
          img={isLoading ? "" : shortDesc.banner}
        />
      </Container>

      <HistoryProfileContainer>
        <div className="p-0 m-0 container-fluid">
          <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex position-relative row">
            <div className="col-lg-9 col-12">
              {/* RIWAYAT */}
              {id === "history" && typeof data.riwayat != "undefined" && (
                <div className="history mb-4">
                  <div className="highlight">
                    <h2 className="mb-4 section-title">{t("highlight")}</h2>
                    {data.riwayat.dataBlockHighlight.map((item, index) => (
                      <div
                        key={index}
                        className="yellow-box"
                        dangerouslySetInnerHTML={{
                          __html: item.descriptionHighlight,
                        }}
                      ></div>
                    ))}
                  </div>

                  <div className="riwayat mt-5">
                    <h2 className="mb-4 section-title">{t("riwayat")}</h2>
                    {data.riwayat.dataBlockRiwayat.map((item, index) => (
                      <div className="item" key={index}>
                        <h2 className="mb-4 section-title">{item.tahun}</h2>
                        <div
                          className="content"
                          dangerouslySetInnerHTML={{ __html: item.content }}
                        ></div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Visi & Misi */}
              {id === "vision-mission" && typeof data.visiMisi != "undefined" && (
                <div className="vision-mission mb-4">
                  <div className="visi">
                    {data.visiMisi.dataBlockVisi.map((item, index) => (
                      <div
                        key={index}
                        className="content"
                        dangerouslySetInnerHTML={{ __html: item.contentVisi }}
                      ></div>
                    ))}
                  </div>

                  <div className="misi">
                    {data.visiMisi.dataBlockMisi.map((item, index) => (
                      <div
                        key={index}
                        className="content"
                        dangerouslySetInnerHTML={{ __html: item.contentMisi }}
                      ></div>
                    ))}
                  </div>
                </div>
              )}

              {/* Bussiness Segment */}
              {id === "business-segment" &&
                typeof data.imageSegmentBusinnes != "undefined" && (
                  <div className="business-segment mb-4 text-center">
                    <img src={data.imageSegmentBusinnes} width="90%" />
                  </div>
                )}

              {/* Anak Perusahaan */}
              {id === "subsidiary" &&
                typeof data.anakPerusahaan != "undefined" && (
                  <div className="subsidiary mb-4 row">
                    {data.anakPerusahaan.map((item, index) => (
                      <a href={item.url} target="blank" className="col-md-6 col-12 card-company" key={index}>
                        <div className="box">                          
                          <div className="image mb-3">
                            <img src={item.imagePerusahaan} alt={item.namaPerusahaan} width="100%" />
                          </div>
                          <div className="perusahaan mb-3">
                            {item.namaPerusahaan}
                          </div>
                          <div className="sub-title">
                            {t("subsidiary_bidang_usaha")}
                          </div>
                          <div className="sub-value mb-3">
                            {item.bidangUsaha}
                          </div>
                          <div className="sub-title">
                            {t("subsidiary_alamat")}
                          </div>
                          <div className="sub-value mb-3">{item.alamat}</div>
                          <div className="sub-value contact d-flex flex-column flex-lg-row">
                            <div className="d-flex w-50 mb-3">
                              <svg
                                width="21"
                                height="21"
                                viewBox="0 0 21 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M9.85651 6.33802C10.3746 5.63981 10.5604 4.90396 9.97444 4.25443C8.65949 2.41445 7.77515 1.27662 7.22044 0.728659C6.16589 -0.313074 4.43112 -0.172163 3.51779 0.727769C3.02723 1.21113 2.86116 1.37712 2.35747 1.88873C-0.448184 4.69589 1.26285 10.6301 5.81139 15.1831C10.3589 19.7351 16.2926 21.4471 19.1041 18.634C19.5689 18.1859 19.9624 17.7921 20.2728 17.4641C21.1678 16.5181 21.3037 14.8598 20.2669 13.7825C19.7354 13.2302 18.6503 12.3886 16.7329 11.0171C16.1457 10.492 15.4494 10.6058 14.811 11.0246C14.504 11.226 14.2805 11.4298 13.8585 11.8522L13.0923 12.6188C12.9914 12.7198 11.621 12.0335 10.2907 10.702C8.95972 9.36965 8.2739 7.99918 8.37435 7.89874L9.14112 7.13155C9.27499 6.99754 9.339 6.93266 9.42108 6.84639C9.59209 6.66666 9.73368 6.50356 9.85651 6.33802ZM14.5057 14.0331L15.2721 13.2662C15.5044 13.0338 15.6549 12.8909 15.7773 12.7923C17.457 13.9985 18.4297 14.757 18.8271 15.1698C19.0656 15.4177 19.0286 15.87 18.8212 16.0892C18.5342 16.3925 18.1613 16.7656 17.7037 17.2069C15.8857 19.0257 11.0959 17.6438 7.22513 13.7692C3.35315 9.89344 1.97188 5.10291 3.7762 3.29761C4.27786 2.7881 4.4368 2.62924 4.92035 2.15278C5.10166 1.97413 5.59552 1.93401 5.81608 2.15189C6.24314 2.57376 7.03534 3.58811 8.20071 5.21145C8.14038 5.28635 8.06503 5.37099 7.97333 5.46737C7.90603 5.5381 7.84996 5.59494 7.72738 5.71764L6.96136 6.48408C5.65821 7.78712 6.76802 10.0048 8.87697 12.1159C10.9845 14.2254 13.203 15.3365 14.5057 14.0331Z"
                                  fill="#5E514D"
                                />
                              </svg>
                              &nbsp;{item.phoneNumber.replace("Telepon", "")}
                            </div>
                            <div className="d-flex w-50 mb-3">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M4 7H6V2H18V7H20C21.1046 7 22 7.89543 22 9V17C22 18.1046 21.1046 19 20 19H18V22H6V19H4C2.89543 19 2 18.1046 2 17V9C2 7.89543 2.89543 7 4 7ZM16 7H8V4H16V7ZM20 9V17H18V15H6V17H4V9H20ZM16 17H8V20H16V17ZM19 11C19 10.4477 18.5523 10 18 10C17.4477 10 17 10.4477 17 11C17 11.5523 17.4477 12 18 12C18.5523 12 19 11.5523 19 11Z"
                                  fill="#5E514D"
                                />
                              </svg>
                              &nbsp;{item.fax}
                            </div>
                          </div>
                          <div className="sub-title">
                            {t("subsidiary_saham")}
                          </div>
                          <div className="sub-value">
                            {item.kepemilikanSaham}
                          </div>
                        </div>
                      </a>
                    ))}
                  </div>
                )}

              {/* Anak Perusahaan */}
              {id === "corporate-culture" && (
                <div className="corporate-culture mb-4">
                  <h2 className="mb-4 section-title">{t("ICCAN")}</h2>
                  <div className="row">
                    {data?.budayaPerusahaan?.map((item, index) => (
                      <div className="col-lg-4">
                        <div className="sc-jRyozQ iDxNNe mb-3">
                          <div className="sc-ezHVNJ duSFbf py-2 px-3">
                            <div className="sc-gNDVjn kcBNcE">
                              <svg
                                width="82"
                                height="55"
                                viewBox="0 0 82 55"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_2896_25508)">
                                  <rect
                                    width="74.4522"
                                    height="74.4522"
                                    rx="12"
                                    transform="matrix(0.695407 -0.718616 0.695407 0.718616 41.4316 16.1198)"
                                    fill="white"
                                    fillOpacity="0.05"
                                  ></rect>
                                  <rect
                                    width="74.4522"
                                    height="74.4522"
                                    rx="12"
                                    transform="matrix(0.695407 -0.718616 0.695407 0.718616 0 1.51038)"
                                    fill="white"
                                    fillOpacity="0.05"
                                  ></rect>
                                </g>
                                <defs>
                                  <clipPath id="clip0_2896_25508">
                                    <path
                                      d="M0 0H58C71.2548 0 82 10.7452 82 24V55H0V0Z"
                                      fill="white"
                                    ></path>
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <p className="sc-kmiuhe epCaga m-0">
                              {item.titleBudaya}
                            </p>
                          </div>
                          <div
                            className="p-3"
                            dangerouslySetInnerHTML={{
                              __html: item.contentBudaya,
                            }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="d-none d-lg-block col">
              <MenuProfile active={active} />
            </div>
          </div>
        </div>
      </HistoryProfileContainer>

      <FooterSection currentPage={t(id)} />
    </div>
  );
};

export default HistoryProfile;
